<script>
	import { onMount } from "svelte";

	import Animation from "../../components/AnimationCSS.svelte";
	import Animatable from "../../components/AnimatableCSS.svelte";
	import Page from "../../newspaper/Page.svelte";

	export let id;
	export let section;
	export let slideProgress;
	export let content = {};
	export let pages;
	export let animationDuration = 1000;

	let play;
	let reset;
	let played = false;
	let mounted = false;

	onMount(() => {
		mounted = true;
	});

	$: if (mounted && slideProgress === 0 && played) {
		reset();
		played = false;
	}

	$: if (mounted && slideProgress !== 0 && slideProgress !== 1 && !played) {
		play();
		played = true;
	}
</script>

<div class="text">
	<div class="t-heading">{@html content.heading}</div>
	<div class="t-text">{@html content.text}</div>
</div>

<div class="facts">
	<div class="fact">
		<div class="fact-icon globe" style="background-image: url({PATH}assets/images/icons/globe.svg)" />
		<div class="t-fact t-fact--noline">
			<div class="t-fact-num">{@html content.num_international}</div>
			<div class="t-fact-label">{@html content.text_international}</div>
		</div>
	</div>
	<div class="fact">
		<div class="fact-icon alex" style="background-image: url({PATH}assets/images/icons/alex.svg)" />
		<div class="t-fact">
			<div class="t-fact-num">{@html content.num_berlin}</div>
			<div class="t-fact-label">{@html content.text_berlin}</div>
		</div>
	</div>
</div>

<div class="animation">
	<Animation duration={animationDuration} bind:play bind:reset>
		{#each pages as page}
			<Animatable left={page.x} top={page.y} anchor={page.anchor || ""} animation={page.animation}>
				<Page src="{PATH}assets/images/content/{section}_{id}_{page.id}" {...page} />
			</Animatable>
		{/each}
	</Animation>
</div>

<style lang="scss">
	.text {
		width: 100%;
		max-width: 620px;
		text-align: center;
		position: relative;
		top: 70px;
		margin: 0 auto;
		z-index: 1;
	}

	.facts {
		display: flex;
		width: calc(100% - 20px);
		max-width: 725px;
		height: 130px;
		margin: 40px auto;
		align-content: bottom;
		position: relative;
		top: 70px;

		@media (max-width: $breakpoint-mobile) {
			height: 100px;
			//margin: 20px auto;
		}
	}

	.fact {
		flex: 1 0 1px;
		display: flex;
		height: 100%;
		justify-content: center;
		align-items: flex-end;

		&:first-child {
			border-right: 1px solid #2a2a2a;
		}
	}

	.fact-icon {
		width: 50px;
		height: 90px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center center;
		position: relative;
		top: -5px;

		&.globe {
			height: 64px;
			top: -6px;
			left: -12px;
		}

		@media (max-width: $breakpoint-mobile) {
			display: none;
		}
	}

	.t-fact {
		height: 100%;
		display: flex;
		flex-direction: column;
		text-align: center;
		justify-content: flex-end;
	}

	:global(.seite) {
		width: 200px;
	}
</style>
